/**
 * @file 日付変換
 *
 */
'use strict';

/**
 * @classname ChangeSelect
 * @classdesc セレクトボックス変更
 */
export default class ChangeSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ChangeSelect.constructor');
		this._$e = $e;
		this._$targetEmpty = $e.closest('.section').find('.empty-target');
		this._$targetNotEmpty = $e.closest('.section').find('.not-empty-target');
		this._$errorTip = $e.closest('.section').find('.error-tip');
		this._$isSwitch = false
		$e.on('change', () => {this.onChange();});
	};

	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeSelect
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeSelect.onChange');
		if(this._$e.val() == 99) {
			// 値の変更
			let textAreaValue =  $('.not-empty-target').val()
			$('.empty-target').val(textAreaValue)
			this._$isSwitch = true
			
			// 見えるかどうかの変更
			this._$targetNotEmpty.attr('style', 'display:none')
			this._$targetEmpty.attr('style', 'display:block')
			// ignore
			this._$targetNotEmpty.addClass('ignore-validate')
			this._$targetEmpty.removeClass('ignore-validate')

		}else {
			// 値の変更
			if(this._$isSwitch) {
				let textAreaValue =  $('.empty-target').val()
				$('.not-empty-target').val(textAreaValue)
				this._$isSwitch = false
			}
			// 見えるかどうかの変更
			this._$targetEmpty.attr('style', 'display:none')
			this._$targetNotEmpty.attr('style', 'display:block')
			// ignore
			this._$targetNotEmpty.removeClass('ignore-validate')
			this._$targetEmpty.addClass('ignore-validate').removeClass('is-invalid')
			
			
			this._$errorTip.removeClass('show')
		}
	}
}
